import Button from "../Button";
import {useNavigate} from "react-router-dom";
import {Server} from "../../api/types";
import {useEffect, useMemo, useState} from "react";
import {agent} from "../../api/agent";
import Table, {TableColumn} from "../table/Table";
import styled from "styled-components";
import LoadingContainer from "../LoadingContainer";

const Center = styled.div`
    display: flex;
    justify-content: center;
`;

const Container = styled.div`
    background-color: var(--content-box-bg);
    margin-top: 1rem;
    padding: 1rem;
    min-width: 40rem;
`;

export default function ServerList() {

    const navigate = useNavigate();
    const [servers, setServers] = useState<Server[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        setLoading(true);
        agent.getServers().then(value => {
            setLoading(false);
            setServers(value);
        });
    }, []);

    const columns: TableColumn[] = [
        {
            key: "name",
            label: "Name",
        },
        {
            key: 'host',
            label: 'Host',
        },
        {
            key: 'port',
            label: 'Port',
        },
        {
            key: 'username',
            label: 'Username',
        },
        {
            key: 'edit',
            label: 'Edit',
            render: (_, row) => {
                return <div onClick={() => {navigate(`/servers?server=${row.id}`)}} style={{cursor: 'pointer'}}><i className="fa-solid fa-pen"></i></div>;
            }
        }
    ];

    const data = useMemo(() => {
        if (!servers) return [];
        return servers;
    }, [servers]);

    return (
        <Center>
            <LoadingContainer open={loading}>
                <Container>
                    <Button className={'primary'} onClick={() => {navigate('/servers?server=new');}}><i className="fa-solid fa-plus"></i></Button>
                    <h2>Server List</h2>
                    <Table columns={columns} data={data}></Table>
                </Container>
            </LoadingContainer>
        </Center>
    );
}